export const LocaleTypeEnum = {
    Pais: 0,
    Regiao: 1,
    UF: 2,
    SetorCensitario: 5,
    SetorCensitarioNeocorp: 13,
};



// WEBPACK FOOTER //
// ./src/enuns/localeType.enum.js